export { default as VictoryPie } from "./victory-pie";
export { default as Slice } from "./slice";


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/es/index.js
// module id = 2489
// module chunks = 0